import React, { Component, createRef } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import ChatsService from '../../controllers/ChatController';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';

class OutgoingChat extends Component {

    constructor(props) {
        super(props)
        this.state = {
            agents: [],
            userId: -1,
            loading: false
        }
        this.changeUser = this.changeUser.bind(this);
        this.setLoading = this.setLoading.bind(this);
        this.openInternal = this.openInternal.bind(this);
        this.changeElement = createRef();
    }

    changeUser = e => {

        //let userId = parseInt(e.target.value);

        this.setState({
            userId: e.target.value
        });
    };

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    showModal = e => {
        this.setLoading(true);

        let user = JSON.parse(localStorage.getItem("fc-logged"));

        ChatsService.getAgents(user.userId, agents => {
            let agentsList = [{
                pin: -1,
                name: this.props.t("none")
            }];
            if (agents.data != null && agents.data.length > 0)
                agentsList = agentsList.concat(agents.data);
            this.setState({
                agents: agentsList
            });
            this.setLoading(false);
        })
    }

    openInternal = e => {
        if (this.state.userId !== "-1") {
            this.setLoading(true);
            let user = JSON.parse(localStorage.getItem("fc-logged"));
            let name = this.changeElement.current.textContent;
            ChatsService.initInternal(user.userId, name, this.state.userId, x => {
                this.setLoading(false);
                this.props.toggleModal();
            });
        } else {
            this.props.toggleModal();
        }
    }

    render() {
        return (<Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.showModal} size="lg">
            <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                <Modal.Header >
                    <Modal.Title><FontAwesomeIcon icon={faPlus} /> {this.props.t("internalchat")}</Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {this.props.t("close")}
                        </Tooltip>}>
                        <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <Form>
                                <Form.Group className="mb-4" controlId="fcAgent">
                                    <Form.Label>{this.props.t("agent")}</Form.Label>
                                    <Form.Select onChange={this.changeUser} value={this.state.userId} ref={this.changeElement}>
                                        {
                                            this.state.agents.map(elem => {
                                                return <option key={elem.pin} value={elem.pin} >{elem.name}</option>
                                            })
                                        }
                                    </Form.Select>
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={this.openInternal}>
                        <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("send")}
                    </Button>
                </Modal.Footer>
            </BlockUi>
        </Modal >)
    }
}

export default withTranslation()(OutgoingChat);